import { hasText } from '~/utils';

export type AddressLike = {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  region?: string | null;
  zipCode?: string | null;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export function formatAddressText(address: AddressLike): string {
  const text = [
    address.addressLine1,
    address.addressLine2,
    address.city,
    address.region,
    address.zipCode,
    address.country,
  ]
    .filter(hasText)
    .join(', ');
  if (text) return text;
  return address.latitude != null && address.longitude != null
    ? `${address.latitude}, ${address.longitude}`
    : '';
}

export function formatCityRegionZip(address: AddressLike): string {
  return [address.city, address.region, address.zipCode]
    .filter(hasText)
    .join(', ');
}

export function hasCoordinates(
  address: AddressLike | null | undefined
): address is AddressLike & { latitude: number; longitude: number } {
  return (
    address != null && address.latitude != null && address.longitude != null
  );
}
